import { trpc } from '@/lib/trpc';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

const useEditPassword = () => {
	const { t } = useTranslation();
	const { mutate, isPending } = trpc.user.passwordUpdate.useMutation({
		onMutate: () => {
			toast.success(t('password.form.success'));
		},
		onError: () => {
			toast.error(t('error.generic'));
		},
	});

	return {
		editPassword: mutate,
		editPasswordLoading: isPending,
	};
};

export default useEditPassword;
